// src/context/UserContext.tsx
import {
  createContext,
  useContext,
  useState,
  useCallback,
  useMemo,
} from 'react';

interface UserContextType {
  user: User | null;
  updateUser: (newUser: User | null) => void;
}

const UserContext = createContext<UserContextType | undefined>(undefined);

export const UserProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [user, setUser] = useState<User | null>(() => {
    try {
      const storedUser = localStorage.getItem('user');
      return storedUser ? JSON.parse(storedUser) : null;
    } catch {
      return null;
    }
  });

  const updateUser = useCallback((newUser: User | null) => {
    if (newUser) {
      const clonedUser = { ...newUser }; // <- força nova referência
      localStorage.setItem('user', JSON.stringify(clonedUser));
      setUser(clonedUser);
    } else {
      localStorage.removeItem('user');
      setUser(null);
    }
  }, []);

  const value = useMemo(() => ({ user, updateUser }), [user, updateUser]);

  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
};

export const useUser = () => {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error('useUser deve ser usado dentro de um UserProvider');
  }
  return context;
};
